<template>
  <v-flex xs12>
    <div style="display: flex; align-items: center">
      <h6 class="body-1 font-weight-bold lightblue--text mr-4">Vigência</h6>
      <v-switch
        color="lightblue"
        :value="isEnabled"
        @change="$emit('toggle-section', 'vigencia')"
      />
    </div>
    <v-layout row wrap v-if="isEnabled">
      <v-flex xs3>
        <v-text-field
          label="Início de Vigência do Endosso (A partir de)"
          class="jns-input"
          :value="inicioVigencia"
          disabled
        />
      </v-flex>

      <v-flex xs3>
        <v-menu
          lazy
          v-model="isDatePickerOpen"
          transition="scale-transition"
          offset-y
          full-width
          :close-on-content-click="false"
          max-width="290px"
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            class="jns-input jns-datepicker"
            label="Final de Vigência"
            :value="fimVigencia"
            append-icon="event"
            placeholder="00/00/00"
            :rules="rules"
            :disabled="disableVigenciaInput"
          />
          <v-date-picker
            :value="fimVigenciaISO"
            @input="updateFimVigencia"
            @change="isDatePickerOpen = false"
            no-title
            scrollable
            locale="pt-BR"
            actions
          />
        </v-menu>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script lang="js">
import moment from "moment";
import { validateVigencyDate, validateVigencyEndDateGreaterThanCurrentApolice } from "@/libs/endorsement";

export default {
  name: "Vigencia",
  props: { policy: Object, model: Object },
  data() {
    return {
      isDatePickerOpen: false,
    };
  },
  computed: {
    disableVigenciaInput() {
      // NOTE: if the component is disabled,
      // it doesn't run the `validation rules`.
      // so we toggle on/off just to make it run...
      return !this.isDatePickerOpen;
    },
    isEnabled() {
      return Boolean(this.model);
    },
    inicioVigencia() {
      return this.model.inicio_vigencia?.format("L");
    },
    fimVigencia() {
      return this.model.fim_vigencia?.format("L");
    },
    fimVigenciaISO() {
      // NOTE: this function is to satisfy v-date-picker.
      return this.model.fim_vigencia?.format(this.model.fim_vigencia._f);
    },
    rules() {
      const self = this;
      const a = "Final da vigência deve ser definida.";
      const b = "Final da vigência deve ser após o inicio.";
      const c = "Final da vigência deve ser maior que a vigência da apólice";
      return [
        (v => Boolean(v) || a),
        (v => {
          if (!Boolean(v)) return false;

          const model = {
            inicio_vigencia: self.model.inicio_vigencia_apolice,
            // date picker formatted using locale, so not ISO.
            fim_vigencia: moment(v, "DD/MM/YYYY")
          };
          return validateVigencyDate(null, model) || b;
        }),
        (v => {
          const fim_vigencia =  moment(v, "DD/MM/YYYY");
          return validateVigencyEndDateGreaterThanCurrentApolice(self.policy, fim_vigencia) || c;
        })
      ];
    }
  },
  methods: {
    updateFimVigencia(value) {
      this.$emit('update-fim-vigencia', value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// ./src/components/Apolice/Steps/Vigencia.vue